var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-input",
    {
      staticClass: "time-tracking__input",
      attrs: {
        "inverted-light": "",
        color: "transparent",
        value: _vm.description,
        placeholder: _vm.$t("working_on")
      },
      on: {
        input: _vm.handleInput,
        focus: _vm.handleFocus,
        blur: _vm.handleBlur,
        keydown: _vm.__keyboardHandleKey
      }
    },
    [
      _c(
        "q-popover",
        {
          ref: "popover",
          staticClass: "time-tracking__input__recent__popover",
          attrs: {
            "no-focus": "",
            "no-refocus": "",
            "keep-on-screen": "",
            "max-height": "300px",
            "anchor-click": false
          },
          model: {
            value: _vm.popover,
            callback: function($$v) {
              _vm.popover = $$v
            },
            expression: "popover"
          }
        },
        [
          _c(
            "div",
            _vm._l(_vm.timeEntries, function(timeEntry, index) {
              return _c(
                "div",
                {
                  key: timeEntry.id,
                  staticClass:
                    "time-tracking__input__recent__entry q-px-md q-py-sm",
                  class: { active: _vm.keyboardIndex === index },
                  on: {
                    click: function($event) {
                      _vm.handleSelectSuggestedTimeEntry(timeEntry)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-between items-center gutter-x-md no-wrap"
                    },
                    [
                      _c("div", { staticClass: "col-auto" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "q-subheading text-dark block ellipsis q-py-sm",
                            class: { "text-italic": !timeEntry.description }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  timeEntry.description ||
                                    _vm.$t("no_description")
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]),
                      timeEntry.project_id
                        ? _c(
                            "div",
                            { staticClass: "col ellipsis" },
                            [
                              _c("project-indicator", {
                                attrs: { project: timeEntry.project.data }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            })
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }